// ── Export helpers ────────────────────────────────────────

const EXPORT_FIELDS = [
  'id', 'title', 'type', 'model', 'params',
  'prompt', 'text_output', 'notes', 'tags',
  'is_public', 'file_url', 'created_at',
];

function clean(entries) {
  return entries.map(e => {
    const obj = {};
    EXPORT_FIELDS.forEach(f => {
      obj[f] = f === 'tags' ? (e[f] || []).join(', ') : (e[f] ?? '');
    });
    return obj;
  });
}

export function exportJSON(entries, filename = 'copypastegenius-export') {
  const data = clean(entries);
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  download(blob, `${filename}.json`);
}

export function exportCSV(entries, filename = 'copypastegenius-export') {
  const data = clean(entries);
  if (!data.length) return;
  const headers = EXPORT_FIELDS;
  const escape = (v) => {
    const str = String(v ?? '').replace(/"/g, '""');
    return /[",\n\r]/.test(str) ? `"${str}"` : str;
  };
  const rows = [
    headers.join(','),
    ...data.map(row => headers.map(h => escape(row[h])).join(',')),
  ];
  const blob = new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  download(blob, `${filename}.csv`);
}

function download(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
